import { useSelector } from 'react-redux'

import ProductsModule from 'modules/products'

const useShowPasses = () => {
    const productsLoading = useSelector(ProductsModule.selectors.getProductsLoading)
    const hasPasses = (useSelector(ProductsModule.selectors.getPasses) as Array<any>).length > 0

    return productsLoading === false && hasPasses === true
}

export default useShowPasses
